import React from 'react';
import { Trophy } from 'lucide-react';

const FloatingSummary = ({ ranking }) => (
  <div className="fixed bottom-6 left-4 right-4 max-w-2xl mx-auto animate-in slide-in-from-bottom-8 z-50">
      <div className="bg-slate-900 border border-slate-800 text-white rounded-3xl p-4 shadow-2xl flex items-center justify-between border-t-emerald-500/50 border-t-2">
        <div className="flex items-center gap-3">
            <div className="bg-amber-400 p-2 rounded-xl shadow-lg shadow-amber-400/20"><Trophy className="w-5 h-5 text-slate-950" /></div>
            <div>
              <p className="text-[10px] font-black uppercase text-slate-500 leading-none mb-1 tracking-widest">Current Leader</p>
              <p className="font-black text-sm truncate max-w-[120px] uppercase tracking-tighter">{ranking[0]?.name || '---'}</p>
            </div>
        </div>
        <div className="text-right">
            <p className="text-[10px] font-black uppercase text-slate-500 leading-none mb-1 tracking-widest">Wins</p>
            <p className="text-xl font-black text-emerald-400 leading-none">{ranking[0]?.wins || 0}</p>
        </div>
      </div>
  </div>
);

export default FloatingSummary;
